import type { TWO_FACTOR_TYPE } from "@tastyworks/shared-utils/misc/constants"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class DeviceChallenge {
  step = ""
  question = ""
  device = ""
  email = ""
  location = ""
  phone = ""
  twoFactorType?: TWO_FACTOR_TYPE | undefined
}

export const DEVICE_CHALLENGE_DESER: SchemaDeSer<DeviceChallenge> =
  new SchemaDeSerBuilder(DeviceChallenge)
    .ofString("email")
    .ofString("device")
    .ofString("location")
    .ofString("question")
    .ofString("phone")
    .ofString("step")
    .toDeSer()
